import { type Module } from "vuex";
import type { DefaultApi, JobAnalysisRequest } from "@/api";
import { JobAnalysis, JobAnalysisWebCall } from "@/models/job_analysis";
import type { State as RootState } from "@/stores";
export interface State {}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getJobAnalysis(
      {},
      payload:
        | number
        | {
            jobAnalysisId: number;
            signal?: AbortSignal;
          },
    ) {
      // Accepts a bare id (existing callers) or `{ jobAnalysisId, signal }` (the poller's cancellable request).
      const { jobAnalysisId, signal } =
        typeof payload === "number"
          ? {
              jobAnalysisId: payload,
              signal: undefined,
            }
          : payload;
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getJobAnalysis(jobAnalysisId, {
        signal,
      });
      return new JobAnalysis(response.data);
    },
    async postJobAnalysis(
      {},
      payload:
        | JobAnalysisRequest
        | {
            request: JobAnalysisRequest;
            signal?: AbortSignal;
          },
    ) {
      const { request, signal } =
        "request" in payload
          ? payload
          : { request: payload, signal: undefined };
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postJobAnalysis(request, { signal });
      return new JobAnalysis(response.data);
    },
    async postJobAnalysisUpload(
      {},
      {
        companyId,
        file,
      }: {
        companyId: number;
        file: File;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postJobAnalysisUpload(companyId, file);
      return new JobAnalysis(response.data);
    },
    async postJobAnalysisWebCall() {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postJobAnalysisWebCall();
      return new JobAnalysisWebCall(response.data);
    },
  },
};
